<template>
    <div class="ChildList" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>
                Wrap Client Enrollments
                <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" />
                <span v-b-tooltip.hover title="Hide/Show Filters" style="margin-left:6px;margin-right:6px;">
                    <font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" />
                </span>
                <EmployeeColumnCustomizationEditor update-event-message="update-table-columns" :table-fields="VisibleFields" table-label="Child List" columns-defaults-endpoint="Wraparound/Clients/GetTableColumns" table-settings-name="Wrap Client Table">
                </EmployeeColumnCustomizationEditor>
            </h2>
            
            <div class="table-filters client-list"  v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Child Status:</label>
                            <select class="form-control" v-model="Filters.Status" @change="RefreshDataTable()">
                                <option value="All">All</option>
                                <option value="Active">Active</option>
                                <option value="Discharged">Discharged</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Program:</label>
                            <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable()">
                                <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="">All</option>
                                <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Team:</label>
                            <select class="form-control" v-model="Filters.TeamID" @change="RefreshDataTable()">
                                <option value="">All</option>
                                <option v-for="teams in $store.state.Teams.TeamEnrollmentList" :value="teams.Id">
                                    {{teams.Name}}
                                </option>
                                <option value="00000000-0000-0000-0000-000000000000">Unassisgned</option>

                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{NumberOfClients}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search Clients:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow-x:auto;">
            <vuetable :fields="VisibleFields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="childrendatatableid"
                      >
                      
                <template slot="ChildRecordLink" scope="props">
                    <div class="ChildRecordLink">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.Id, props.rowData)">{{ props.rowData.ClientName }}</span>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>

<script>
    //import services
    import { ClientsAPI } from '../../../services/api/Foster/ClientsAPI.js';
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);
    import { faTable } from '@fortawesome/free-solid-svg-icons';
    library.add(faTable);
    import EmployeeColumnCustomizationEditor from "../../Core/ItemEditors/EmployeeColumnCustomizationEditor.vue";

    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [TableScrollerSupport],
        created() {
            this.$store.commit("Clients.ClientProfiles.Clear");
            this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            const clientsAPI = new ClientsAPI(this.$baseURL);
            this.clientsAPI = clientsAPI;
            EventBus.$on('global-update-initiated', this.GetChildren);
            EventBus.$on('update-table-columns', this.RefreshDataTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
            EventBus.$off('update-table-columns');
        },
        props: [],
        data: function () {
            return {
                CaseManagers: '',
                NumberOfClients: '',
                search: "",
                VisibleFields: [],
                Filters: {
                    Status: "Active",
                    TeamID: "",
                },
                ChildrenTableOptions: {
                    Fields: [
                        {
                            name: '__slot:ChildRecordLink',
                            title: 'Name',
                            sortField: 'ClientName',
                        },
                        {
                            name: 'ClientName',
                            title: 'Name',
                            visible: false,
                            Save: true
                        },
                        {
                            name: 'DOB',
                            title: "DOB",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DOB'
                        },
                        {
                            name: 'TeamName',
                            title: "Team",
                            sortField: 'TeamName'
                        },
                        {
                            name: 'ReferralDate',
                            title: "Referral",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'ReferralDate'
                        },
                        {
                            name: 'FirstFaceToFaceDate',
                            title: "First F2F",
                            callback: 'formatDate|MM/DD/YY|Pending',
                            sortField: 'FirstFaceToFaceDate'
                        },
                        {
                            name: 'FirstClinicalContactDate',
                            title: "First Clinical Contact",
                            callback: 'formatDate|MM/DD/YY|Pending',
                            sortField: 'FirstClinicalContactDate'
                        },
                        {
                            name: 'DischargeDate',
                            title: "Discharge",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DischargeDate'
                            //width: "15%"
                        },
                        //{
                        //    name: 'ServiceSchedule',
                        //    title: "Service Schedule",
                        //    sortField: 'ServiceSchedule',
                        //    dataClass: 'd-none d-xl-table-cell',
                        //    titleClass: 'd-none d-xl-table-cell',
                        //},
                        {
                            name: 'Location',
                            title: "Location",
                            sortField: 'Location'
                        },
                        {
                            name: 'ContactStatus',
                            title: "Contact Status",
                            sortField: 'ContactStatus'
                        },
                        {
                            name: 'Population',
                            title: "Population",
                            sortField: 'Population'
                        },
                        {
                            name: 'Facilitator',
                            title: "Facilitator",
                            sortField: 'Facilitator'
                        },
                        {
                            name: 'ParentPartner',
                            title: "ParentPartner",
                            sortField: 'ParentPartner'
                        },
                        {
                            name: 'BehavioralHealthSpecialist',
                            title: "Behavioral Health Specialist",
                            sortField: 'BehavioralHealthSpecialist'
                        },
                        {
                            name: 'Clinician',
                            title: "Clinician",
                            sortField: 'Clinician'
                        },
                        {
                            name: 'NumberOfDaysInProgram',
                            title: "Days In Program",
                            sortField: 'NumberOfDaysInProgram'
                        },
                        {
                            name: 'AssignedSocialWorker',
                            title: "Assigned Social Worker",
                            sortField: 'AssignedSocialWorker',
                        },
                        {
                            name: 'ChurchRelationships',
                            title: "Church Relationships",
                            sortField: 'ChurchRelationships',
                            callback: (value) => (value === true) ? 'Yes' : 'No',
                        },
                        {
                            name: 'AgeOfClient',
                            title: "AgeOfClient",
                            sortField: 'AgeOfClient',
                        },
                        {
                            name: 'LastPOC',
                            title: "LastPOC",
                            sortField: 'LastPOC',
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'POCDue',
                            title: "POCDue",
                            sortField: 'POCDue',
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'TreatmentPlanImplementationDate',
                            title: "Tx Plan Imp",
                            sortField: 'TreatmentPlanImplementationDate',
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'MeasuresDueMessage',
                            title: "Measures",
                            sortField: 'MeasuresDueMessage'
                        },
                        {
                            name: 'Address',
                            title: "Address",
                            sortField: 'Address'
                        },
                        {
                            name: 'CaseFileStatus',
                            title: "Case File Status",
                            sortField: 'CaseFileStatus'
                        },
                        {
                            name: 'CID',
                            title: "CID",
                            sortField: 'CID'
                        },
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetChildren(true);
            },
            GetChildren(displayLoad = false) {
                console.log("get children from child list ran");
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/Clients/GetClientEnrollments", this.Filters, this.GetChildrenSuccess,()=>{}, displayLoad);
            },
            GetChildrenSuccess(response) {
                this.RefreshTableFields(response);
                let filteredArray = response.data.data.ChildList.filter(function (obj) {
                    return obj.Show !== false;
                });
                this.$store.commit("Clients.ClientEnrollmentsList.ReplaceListOnly", filteredArray);
                this.$refs.datatable.refresh();
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultVal = '') {
              return (value == null)
                ? defaultVal
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenChildRecord(subProgramMembershipID, childRecordData) {
                this.$store.commit("Clients.ClientProfiles.Append", childRecordData);
                this.$parent.ChangePaneShown(subProgramMembershipID);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.$store.state.Clients.ClientEnrollmentsList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;                  
            },
            RefreshTableFields(response) {
                let vm = this;
                let outputArray = response.data.data.Columns.toString().split(',');
                let outputFields = [];

                //save fields from frontend that contain the property save.
                let columnsToSave = [];
                this.ChildrenTableOptions.Fields.forEach(function (col) {
                    if (col.hasOwnProperty("Save")) {
                        columnsToSave.push(col);
                    }
                });

                for (var i = 0; i < outputArray.length; i++)
                {
                    let fieldExists = this.ChildrenTableOptions.Fields.map(function (vc) { return vc.name; }).indexOf(outputArray[i]);
                    if (fieldExists != -1) {
                        outputFields[i] = this.ChildrenTableOptions.Fields[fieldExists];
                    }
                }
                this.VisibleFields = outputFields.concat(columnsToSave);
                this.$nextTick(function () {
                    vm.$refs.datatable.normalizeFields();
                });
            },
        },
        components: {
            Vuetable,
            EmployeeColumnCustomizationEditor
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        mounted() {
            this.Filters.SubProgramID = "12e83da9-e178-4db2-9077-6097f277443a";//Inland/Desert Wrap
            this.GetChildren(true);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>